import React from 'react'
import { useSelector } from 'react-redux';
import ItemRow from './ItemRow/ItemRow';
import './ItemsTable.css'
import { getPermissions } from '../../utils/various';

const ItemsTable = ({ data, type, handleEdit, handleView, handleDelete, disabled }) => {

    const { sessionData } = useSelector(state => state.session);
    const permissions = getPermissions(sessionData?.role);
    const isAdmin = permissions.admin;

    let headers = [
        {
            name: 'Id',
            key: 'id',
        },
        {
            name: 'Nombre',
            key: 'name',
        },
        {
            name: 'Fecha',
            key: 'date',
        },
        {
            name: type !== 'contracts' ? 'Teléfono' : 'Lugar de velación',
            key: 'phone'
        }
    ];

    if (type === "users") {
        headers = [
            {
                name: 'Username',
                key: 'username',
            },
            {
                name: 'Nombre',
                key: 'name',
            },
            {
                name: 'Email',
                key: 'email',
            },
            {
                name: 'Teléfono',
                key: 'tel'
            }
        ];
    }

    if (type === "report") {
        headers = [
            {
                name: 'Nombre',
                key: 'name',
            },
            {
                name: 'Cantidad solicitudes',
                key: 'requestsQuantity',
            }
        ];
    }

    return (
        <div className="mx-5 my-2 border border-gray-200 rounded-lg shadow-md max-h-[450px] table-wrp block relative overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-500 bg-white border-collapse">
                <thead className="sticky top-0 headerTable">
                    <tr>
                        {headers.map((header, idx) =>
                            <th key={idx} scope="col" className="px-6 py-4">{header.name}</th>
                        )}
                        {type !== 'report' && <th colSpan={2} scope="col" className="px-6 py-4"></th>}
                    </tr>
                </thead>
                <tbody className="overflow-y-scroll">
                    {data && data.length > 0 ? data?.map((item, idx) => <ItemRow disabled={disabled} permissions={permissions} isAdmin={isAdmin} type={type} idx={idx} key={item.id} item={item} handleEdit={handleEdit} handleView={handleView} handleDelete={handleDelete} />) :
                        <tr>
                            <td colSpan={5} className="px-6 py-4 text-center">No hay datos</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default ItemsTable;